module.exports = __webpack_public_path__ + "img/illu1@2x.fdf160c0.png";